module.exports = __webpack_public_path__ + "img/icon-drapeau-quiz.4ec2fbeb.svg";